<div class="sso-callback-container">
    <div class="sso-callback-card">
        <div class="modern-spinner"></div>
        <h3 class="title">Memverifikasi Sesi...</h3>
        <p class="subtitle">Mohon tunggu sebentar, kami sedang mengamankan koneksi Anda dengan SSO CANDI Badung.</p>
    </div>
</div>